import { useSearchParams } from "react-router";
import { INTERESTS } from "../../lib/contactValidation.js";
import { SITE } from "../../lib/site.js";
import ContactForm from "../ContactForm/ContactForm.jsx";
import styles from "./ContactPage.module.css";

/**
 * The contact and demo pages: the heading and what happens next on the left, the form on a
 * frosted-glass panel on the right, over the road photograph. On a phone it is one column in
 * reading order: heading, form, next steps, direct contacts. `steps` is optional.
 */
export default function ContactPage({ title, lead, steps, interest = "general", path }) {
  const [params] = useSearchParams();
  const fromQuery = params.get("interest");
  const chosen = INTERESTS.some((i) => i.value === fromQuery) ? fromQuery : interest;
  return (
    <section className={styles.page} aria-labelledby="contact-title">
      <div className={`container ${styles.layout}`}>
        <header className={styles.intro}>
          <h1 id="contact-title" className={styles.title}>
            {title}
          </h1>
          <p className={styles.lead}>{lead}</p>
        </header>

        <div className={styles.panel}>
          <ContactForm key={chosen} interest={chosen} page={path} />
        </div>

        <div className={styles.aside}>
          {steps ? (
            <div className={styles.block}>
              <h2 className={styles.blockTitle}>What happens next</h2>
              <ol className={styles.steps}>
                {steps.map((s) => (
                  <li key={s.title}>
                    <strong>{s.title}</strong>
                    <span>{s.text}</span>
                  </li>
                ))}
              </ol>
            </div>
          ) : null}
          <div className={styles.block}>
            <h2 className={styles.blockTitle}>Prefer to talk?</h2>
            <p className={styles.direct}>
              <a href={SITE.phoneHref}>{SITE.phone}</a>
              <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
            </p>
            <ul className={styles.offices}>
              {SITE.offices.map((o) => (
                <li key={o.label}>
                  <strong>{o.label}</strong>
                  {o.city}
                  {o.region ? `, ${o.region}` : ""}, {o.country}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
